import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moduleStyles from '@dtsl/css-toggle-button/dist/index.module.css';
const ToggleButton = _ref => {
  let {
    children,
    className = '',
    dataTestId = ''
  } = _ref;
  const sliderRef = useRef();
  const selectedItemIndex = children.findIndex(child => child.props.isSelected) ?? 0;
  const [selectedItem, setSelectedItem] = useState(selectedItemIndex);
  const toggleButtonClass = classNames({
    [moduleStyles['sib-toggle-button-wrapper']]: true,
    [className]: !!className
  });
  const handleButtonClick = idx => {
    setSelectedItem(idx);
  };
  useEffect(() => {
    if (sliderRef && sliderRef.current) {
      const {
        current: slider,
        current: {
          parentElement
        }
      } = sliderRef;
      if (parentElement) {
        const selectedToggleButton = parentElement.childNodes[selectedItem + 1];
        slider.style.left = selectedToggleButton.offsetLeft + 'px';
        slider.style.top = '4px';
        slider.style.width = selectedToggleButton.offsetWidth + 'px';
        slider.style.height = selectedToggleButton.offsetHeight + 'px';
      }
    }
  }, [selectedItem]);
  useEffect(() => {
    setSelectedItem(selectedItemIndex);
  }, [selectedItemIndex]);
  return /*#__PURE__*/React.createElement("div", {
    className: toggleButtonClass,
    "data-testid": dataTestId ? dataTestId : null
  }, /*#__PURE__*/React.createElement("div", {
    ref: sliderRef,
    className: moduleStyles['sib-toggle-button--slider']
  }), React.Children.map(children, (child, index) => {
    return /*#__PURE__*/React.cloneElement(child, {
      key: index,
      onClick: e => {
        e.preventDefault();
        const {
          onClick
        } = child.props;
        handleButtonClick(index);
        onClick();
      },
      className: `${[moduleStyles['sib-btn']]} ${selectedItem === index ? moduleStyles['sib-btn--selected'] : ''} `
    });
  }));
};
ToggleButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  dataTestId: PropTypes.string
};
export default ToggleButton;